/* tslint:disable */

declare var Object: any;
export interface PadronOlpInterface {
  "apellido"?: string;
  "nombre"?: string;
  "numDoc"?: number;
}

export class PadronOlp implements PadronOlpInterface {
  "apellido": string;
  "nombre": string;
  "numDoc": number;
  constructor(data?: PadronOlpInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PadronOlp`.
   */
  public static getModelName() {
    return "PadronOlp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PadronOlp for dynamic purposes.
  **/
  public static factory(data: PadronOlpInterface): PadronOlp{
    return new PadronOlp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PadronOlp',
      plural: 'PadronOlps',
      path: 'PadronOlps',
      idName: 'numDoc',
      properties: {
        "apellido": {
          name: 'apellido',
          type: 'string'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
        "numDoc": {
          name: 'numDoc',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/PadronOlp.ts